import React from "react";
import { useSelector } from "react-redux";
import PartiesPage from "../../components/parties";
import Page from "../../components/general/page";
import { useContext } from "react";
import { RegistryContext } from "../../contexts/RegistryContext";
import { useIntl } from "react-intl";

const PartiesView = props => {
  const { pageRef } = props;
  const company = useSelector(state => state.company);
  const main = useSelector(state => state.main);
  const registryStore = useContext(RegistryContext);

  const intl = useIntl();

  const selectedCompanyName = company?.companies?.find(el => el.id === main.clientIdSelected);

  const onCloseFullScreenCreate = () => {
    registryStore.setFullScreenCreateNew(false);
    registryStore.setIbanPaymentFormError(null);
    registryStore.setMunicipalityError(null);
    registryStore.setCapError(null);
    registryStore.setProvinceError(null);
    registryStore.setEmailError(null);
    registryStore.setPecError(null);
    registryStore.setIbanError(null);
    registryStore.setVatError(null);
    registryStore.setTaxIdError(null);
    registryStore.setInstallments([
      {
        dueDate: { number: "30", interval: "giorni", from: "month-end" },
        amount: 100,
        iban: "",
        paymentMethod: "MP05"
      }
    ]);
  };

  return (
    <Page
      pageRef={pageRef}
      title={intl.formatMessage({id: "addressBook.title", defaultMessage: "RUBRICA"})?.toUpperCase()}
      subtitle={
        selectedCompanyName?.ragioneSociale + " / " + intl.formatMessage({ id: "generic.fiscalCodeAbbreviation" }) + " " + main.companySelected
      }
      actionClick={onCloseFullScreenCreate}      
    >
      <PartiesPage installments={registryStore.installments} />
    </Page>
  );
};

export default PartiesView;
